import { Box, Typography, useTheme, Stack, useMediaQuery } from "@mui/material";
import React, { useContext, useState } from "react";
import { themeColors } from "../../assets/data/data";
import { Check } from "@mui/icons-material";
import { colors } from "../../theme/theme";
import ThemeContext from "../../context/ThemeProvider";
import CustomModal from "../Common/CustomModal";

const ThemeChangeModal = ({ open, handleClose }) => {
  const theme = useTheme();

  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { switchTheme, selectedTheme } = useContext(ThemeContext);

  const [currentTheme, setCurrentTheme] = useState(selectedTheme || "");

  return (
    <CustomModal
      open={open}
      handleClose={handleClose}
      title={"Settings"}
      onSave={() => {
        if (currentTheme) {
          switchTheme(currentTheme);
          handleClose();
        }
      }}
      onCancel={() => {
        switchTheme("default");
        handleClose();
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
        }}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Typography
            sx={{
              fontFamily: "'Gotham', sans-serif",
              fontSize: "20px",
              color: colors.primary,
            }}
          >
            Choose Theme?
          </Typography>
          <Typography
            onClick={() => setCurrentTheme("default")}
            sx={{
              fontFamily: "'Gotham', sans-serif",
              fontSize: "16px",
              color: colors.primary,
              fontWeight: "400",
              textDecorationLine: "underline",
              cursor: "pointer",
            }}
          >
            Choose default theme?
          </Typography>
        </Stack>

        <Box
          sx={{
            mt: 6,
            display: "flex",
            flexWrap: "wrap",
            justifyContent: smallScreen ? "center" : "space-evenly",
            gap: 2,
            width: "100%",
          }}
        >
          {themeColors.map((color) => (
            <Box
              key={color.id}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                mb: smallScreen ? 2 : 0,
                flex: "0 1 120px",
                maxWidth: "120px",
              }}
            >
              <Box
                sx={{
                  height: "100px",
                  width: "100px",
                  borderRadius: "30px",
                  backgroundColor: color.color,
                  cursor: "pointer",
                  border:
                    currentTheme === color.value
                      ? `2px solid ${theme.palette.text.primary}`
                      : "none",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => setCurrentTheme(color.value)}
              >
                {currentTheme === color.value && (
                  <Check sx={{ fontSize: "50px", color: "#fff" }} />
                )}
              </Box>
              <Typography
                sx={{
                  fontFamily:
                    currentTheme === color.value
                      ? "'Gotham', sans-serif"
                      : "'Gotham', sans-serif",
                  color: colors.primary,
                  fontSize: {
                    xs: "14px",
                    sm: "16px",
                  },
                  fontWeight: currentTheme === color.value ? "600" : "400",
                  mt: smallScreen ? 1 : 2,
                  maxWidth: "75%",
                  textAlign: "center",
                }}
              >
                {color.title}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </CustomModal>
  );
};

export default ThemeChangeModal;
